import useAppDispatch from 'core/hooks/useAppDispatch';
import useAppSelector from 'core/hooks/useAppSelector';
import DesignButton from 'components/button/DesignButton';
import {
  selectShowCourierRoute,
  selectShowDeliveriesRoute, selectShowMicrozones,
  selectShowStopRoute,
  setShowCourierRoute,
  setShowDeliveriesRoutes, setShowMicrozones,
  setshowStopsRoute,
} from 'pages/itinerary/MapSlice';

export interface InfoPanelProps {
  handlePanelClose: () => void;
}

const InfoPanel = ({ handlePanelClose }: InfoPanelProps) => {
  const dispatch = useAppDispatch();
  const showDeliveriesRoute = useAppSelector(selectShowDeliveriesRoute);
  const showStopsRoute = useAppSelector(selectShowStopRoute);
  const showCourierRoute = useAppSelector(selectShowCourierRoute);
  const showMicrozones = useAppSelector(selectShowMicrozones)

  const togleStopsRoute = () => {
    dispatch(setshowStopsRoute(!showStopsRoute));
  };

  const togleDeliveriesRoute = () => {
    dispatch(setShowDeliveriesRoutes(!showDeliveriesRoute));
  };

  const toggleCourierRoute = () => {
    dispatch(setShowCourierRoute(!showCourierRoute));
  };

  const toggleMigrozones = () => {
    dispatch(setShowMicrozones(!showMicrozones));
  }

  return (
    <div className="absolute top-0 right-0 max-w-xs bg-white py-1 px-1 font-medium text-design-black shadow-lg dark:bg-design-gray 2xl:px-3">
      <div className="flex items-center justify-between">
        <h3 className="font-bold dark:text-white 2xl:text-base">Legend</h3>

        <DesignButton
          onClickHandler={handlePanelClose}
          className=" w-fit bg-design-black px-4 py-2 text-white"
        >
          X
        </DesignButton>
      </div>
      <div className="grid grid-cols-[1fr_4fr] items-center gap-1 2xl:gap-3">
        <div className="h-3 w-7 bg-darker-red" />
        <div className="dark:text-white">Pending delivery</div>
        <div className="h-3 w-7 bg-yellow" />
        <div className="dark:text-white">Canceled delivery</div>
        <div className="h-3 w-7 bg-green" />
        <div className="dark:text-white">Delivered</div>
        <div className="h-3 w-7 bg-blue" />
        <div className="dark:text-white">Contains approximated coordinates</div>
        <div className="h-3 w-7 bg-fuchsia-500" />
        <div className="dark:text-white">Contains R30 retours</div>
        <div className="h-3 w-7 bg-bright-blue" />
        <div className="dark:text-white">Locker Visit</div>
        <div className="h-3 w-7 bg-orange" />
        <div className="dark:text-white">PUDO Visit</div>
        <div>
          <img
            className="h-4 w-4"
            src="/arrow_deliveries.png"
            alt="Legend deliveries"
          />
        </div>
        <div className="dark:text-white">Actual delivery route</div>
        <div>
          <img
            className="h-4 w-4"
            src="/arrow_stops.png"
            alt="Legend deliveries"
          />
        </div>
        <div className="dark:text-white">Expected route</div>
      </div>
      <h3 className="mb-2 mt-1 text-sm font-bold dark:text-white 2xl:text-base">
        Controls
      </h3>
      <div className="mt-2 flex items-center">
        <input
          id="stops-checkbox"
          type="checkbox"
          checked={showStopsRoute}
          className="h-4 w-4  rounded  focus:ring-2"
          onChange={togleStopsRoute}
        />
        <label
          htmlFor="stops-checkbox"
          className="ml-2 text-sm font-normal dark:text-white"
        >
          Show IDM proposed route
        </label>
      </div>
      <div className="mt-2 flex items-center">
        <input
          id="deliveries-checkbox"
          type="checkbox"
          checked={showDeliveriesRoute}
          className="h-4 w-4  rounded  focus:ring-2"
          onChange={togleDeliveriesRoute}
        />
        <label
          htmlFor="deliveries-checkbox"
          className="ml-2 text-sm font-normal dark:text-white"
        >
          Show actual delivery route
        </label>
      </div>
      <div className="mt-2 flex items-center">
        <input
          id="courier-checkbox"
          type="checkbox"
          checked={showCourierRoute}
          className="h-4 w-4  rounded  focus:ring-2"
          onChange={toggleCourierRoute}
        />
        <label
          htmlFor="courier-checkbox"
          className="ml-2 text-sm font-normal dark:text-white"
        >
          Show courier live tracking
        </label>
      </div>
      <div className="mt-2 flex items-center">
        <input
          id="courier-checkbox"
          type="checkbox"
          checked={showMicrozones}
          className="h-4 w-4  rounded  focus:ring-2"
          onChange={toggleMigrozones}
        />
        <label
          htmlFor="courier-checkbox"
          className="ml-2 text-sm font-normal dark:text-white"
        >
          Show microzones
        </label>
      </div>
    </div>
  );
};

export default InfoPanel;
